/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-date-picker';
import { Controller } from 'react-hook-form';
import styles from './DatePicker.module.scss';

function DatePickerComponent({
  control,
  name,
  isRequired,
  errors,
  className,
  classNamedark,
  maxDate,
  minDate,
  label,
  labelstyle,
  labeldarkstyle,
  mandatory,
}) {
  const isDark = localStorage.getItem('theme') === 'dark';
  const labelStyles = isDark ? labeldarkstyle : labelstyle;

  return (
    <div className="form-group">
      {label && (
        <>
          <label htmlFor={name} className={labelStyles ?? labelstyle}>
            {label}
          </label>
          {(mandatory || isRequired) && <span style={{ color: 'red', marginLeft: '3px' }}>*</span>}
        </>
      )}
      <Controller
        control={control}
        name={name}
        rules={{
          required: {
            value: isRequired,
            message: `${label} is required.`,
          },
        }}
        render={({ field }) => {
          const getDateValue = (val) => {
            if (!val || val === '') return null;
            const date = new Date(val);
            return Number.isNaN(date.getTime()) ? null : date;
          };

          return (
            <div className={isDark ? styles.datePickerDark : styles.datePickerContainer}>
              <DatePicker
                id={name}
                onChange={(date) => field.onChange(date)}
                value={getDateValue(field.value)}
                format="MM/dd/y"
                maxDate={maxDate}
                minDate={minDate}
              />
            </div>
          );
        }}
      />
      <p
        style={{
          color: 'red',
          marginTop: '5px',
          fontSize: '14px',
        }}
      >
        {' '}
        {
          // Shows if error exist
          errors[name] && errors[name].message
        }{' '}
      </p>
    </div>
  );
}

DatePickerComponent.propTypes = {
  control: PropTypes.oneOfType([PropTypes.object]).isRequired,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  errors: PropTypes.PropTypes.oneOfType([PropTypes.object]).isRequired,
  className: PropTypes.string,
  classNamedark: PropTypes.string,
  label: PropTypes.string,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
  labelstyle: PropTypes.string,
  labeldarkstyle: PropTypes.string,
  mandatory: PropTypes.bool,
};
DatePickerComponent.defaultProps = {
  isRequired: false,
  classNamedark: null,
  className: 'default-input-class',
  maxDate: null,
  minDate: null,
  label: 'Date',
  labelstyle: null,
  labeldarkstyle: null,
  mandatory: false,
};

export default DatePickerComponent;
